var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30C25.6066 30 28.125 27.4816 28.125 24.375C28.125 21.2684 25.6066 18.75 22.5 18.75C19.3934 18.75 16.875 21.2684 16.875 24.375C16.875 27.4816 19.3934 30 22.5 30Z",
    stroke: "black",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 39.375H26.6666C32.5187 39.375 35.4446 39.375 37.5465 37.9961C38.4562 37.3991 39.2376 36.6321 39.8456 35.7388C41.25 33.6752 41.25 30.8023 41.25 25.0567C41.25 19.3114 41.25 16.4385 39.8456 14.3749C39.2376 13.4815 38.4562 12.7144 37.5465 12.1175C36.1957 11.2315 34.5051 10.9148 31.9162 10.8016C30.6808 10.8016 29.6173 9.88253 29.3751 8.69318C29.0115 6.90917 27.4161 5.625 25.5632 5.625H19.4368C17.5838 5.625 15.9884 6.90917 15.625 8.69318C15.3827 9.88253 14.3191 10.8016 13.0838 10.8016C10.495 10.9148 8.80416 11.2315 7.45357 12.1175C6.54366 12.7144 5.7624 13.4815 5.15441 14.3749C3.75 16.4385 3.75 19.3114 3.75 25.0567C3.75 30.8023 3.75 33.6752 5.15441 35.7388C5.7624 36.6321 6.54366 37.3991 7.45357 37.9961C9.55545 39.375 12.4814 39.375 18.3333 39.375Z",
    stroke: "black",
    strokeWidth: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 18.75H33.75",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f06dd6614d6b65202c32abad01cbf7d9.svg";
export { ForwardRef as ReactComponent };